module.exports = __webpack_public_path__ + "img/rastreo.765e4b18.jpg";